
export const locatedOptions = [
  { option: 'marina', label: 'A Marina' },
  { option: 'business', label: 'A Business' },
  { option: 'privateResidence', label: 'A Private Residence' },
];